export const refNotUpdatedReasons = {
    DUPLICATE_NUM_PDD: "Num PDD duplicato",
    DOUBLE_SALES_POTENTIAL: "Doppia prev venduto"
}

export const NO_ASSIGNABLE_PRODUCT = 'dossier.noAssignableProduct'